/* CARSTN - Latest Release (dynamic)
   Pulls the latest MAIN release (no remixes/chill mixes) from the feeds worker
   and updates every "latest release" reference on the homepage: the Latest
   Release section, the hero pill + CTA + now-playing meta, and the announce bar.
   No worker URL set, or a failed fetch, leaves the manual content untouched. */
(function () {
  var rel = document.querySelector("#music.release[data-worker-url]");
  if (!rel) return;
  var worker = (rel.getAttribute("data-worker-url") || "").trim().replace(/\/+$/, "");
  if (!worker) return;

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  fetch(worker + "/latest-release", { credentials: "omit" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (rl) {
      if (!rl || !rl.name) return;
      var name = rl.name;

      /* 1) Latest Release section */
      var title = rel.querySelector(".release__title");
      if (title) title.textContent = name;
      var head = rel.querySelector(".section-title");
      if (head) head.textContent = name + ".";
      if (rl.cover) {
        var cover = rel.querySelector(".release__cover");
        if (cover) {
          cover.style.padding = "0"; // let the artwork fill the frame, no gradient border showing
          cover.innerHTML = '<img src="' + esc(rl.cover) + '" alt="' + esc(name) +
            '" style="width:100%;height:100%;object-fit:cover;border-radius:12px;display:block">';
        }
      }
      var relPlay = rel.querySelector(".hero__cta a.btn--primary");
      if (relPlay && rl.url) { relPlay.setAttribute("href", rl.url); relPlay.setAttribute("target", "_blank"); relPlay.setAttribute("rel", "noopener"); }

      /* 2) Hero */
      var heroTag = document.querySelector("section.hero .hero__tag");
      if (heroTag) heroTag.innerHTML = '<span class="live-dot" style="margin-right:6px"></span>Out now · ' + esc(name);
      var heroCta = document.querySelector("section.hero .hero__cta a.btn--primary");
      if (heroCta) {
        heroCta.textContent = "▶ Play „" + name + "“";
        if (rl.url) { heroCta.setAttribute("href", rl.url); heroCta.setAttribute("target", "_blank"); heroCta.setAttribute("rel", "noopener"); }
      }
      document.querySelectorAll("section.hero .hero__meta span").forEach(function (s) {
        var strong = s.querySelector("strong");
        if (strong && /latest release|now playing/i.test(strong.textContent)) {
          var n = strong.nextSibling;
          if (n && n.nodeType === 3) n.textContent = " " + name;
          else s.appendChild(document.createTextNode(" " + name));
        }
      });

      /* 3) Announce bar */
      var ann = document.querySelector(".announce .links span");
      if (ann) ann.textContent = "☀ „" + name + "“ out now";

      /* 4) Marquee items flagged as the latest release (originals + loop clones) */
      document.querySelectorAll('[data-marquee="release"]').forEach(function (el) {
        el.textContent = "☀ " + name + " out now";
      });
    })
    .catch(function () { /* keep manual content */ });
})();
